export default class MiniGamesContextTag {
  public id: string = null;
  public model: any = null;
  public source: string = null;
  public type: string = null;
}
